export default "__VITE_ASSET__CmuJY334__$_?component__"